import { useLoadingAnimation } from '@/components/LoadingAnimation/useLoadingAnimation.hook';
import { DEFAULT_ERROR_MESSAGE } from '@/config/text.const';
import { HttpStatusCode } from '@/services/http/HttpStatusCodes';
import { importingToolHttpClient } from '@/services/http/clients/importingToolHttpClient';
import { notificationService } from '@/services/notification/notification.client';

export type ImportingToolUploadFields = {
  file: File | undefined;
};

type FileUploadProps = {
  values: ImportingToolUploadFields;
  successCallback?: Function;
};

export default function useImportingToolUploadDocument() {
  const { toggleLoadingAnimation } = useLoadingAnimation();

  const onFileUpload = async ({ values, successCallback }: FileUploadProps) => {
    toggleLoadingAnimation(true);
    const uploadedFile = new FormData();

    if (values.file) {
      uploadedFile.append('importFile', values.file);
    }

    return importingToolHttpClient.post('/upload-document', uploadedFile, {
      headers: {
        'Content-Type': 'multipart/form-data'
      },
    })
      .then((uploadResult) => {
        if (uploadResult?.status === HttpStatusCode.OK) {
          successCallback?.();
          notificationService.open({
            title: 'Success',
            text: 'File uploaded successfully',
            type: 'success'
          });
        }
      })
      .catch((err) => {
        notificationService.open({
          title: 'Upload file',
          text: err?.message ?? DEFAULT_ERROR_MESSAGE,
          type: 'danger'
        });
      })
      .finally(() => toggleLoadingAnimation(false));
  };

  return {
    onFileUpload
  };
}
